<template>
  <div>{{ content.timeslot.label }}</div>
</template>

<script>
import BaseMessage from '@/layout/messages/BaseMessage.vue'

export default {
  name: 'TimeslotChoice',
  extends: BaseMessage
}

</script>
